import { render } from "./DADataTableLazy.vue?vue&type=template&id=55bed812"
import script from "./DADataTableLazy.vue?vue&type=script&lang=js"
export * from "./DADataTableLazy.vue?vue&type=script&lang=js"

import "./DADataTableLazy.vue?vue&type=style&index=0&id=55bed812&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__